import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material';
import styled from 'styled-components';
import COLORS from '../../colors';

interface SelectFieldProps {
  id: string;
  label: string;
  value?: string | '';
  options: Array<string>;
  onChange?: (value: string) => void;
}

const StyledFormControl = styled(FormControl)`
  width: 100%;
  margin-top: 8px;
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: ${COLORS.NEUTRAL_700};
    }
    &:hover fieldset {
      border-color: ${COLORS.PRIMARY_500};
    }
  }
`;

const StyledInputLabel = styled(InputLabel)`
  color: ${COLORS.NEUTRAL_500} !important;
`;

const StyledSelect = styled(Select)`
  .MuiSelect-icon {
    color: ${COLORS.NEUTRAL_500};
  }

  .MuiSelect-select {
    color: ${COLORS.WHITE};
  }
`;

const SelectField = ({
  id,
  label,
  options,
  value,
  onChange
}: SelectFieldProps) => {
  const handleChange = (event: SelectChangeEvent) => {
    const value = event?.target?.value;

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <StyledFormControl variant="outlined" sx={{ maxWidth: '65%' }}>
      <StyledInputLabel id={`${id}-select-label`} required>
        {label}
      </StyledInputLabel>
      <StyledSelect
        id={`${id}-select`}
        labelId={`${id}-select-label`}
        label={label}
        value={value ?? ''}
        onChange={(event: SelectChangeEvent<any>) => handleChange(event)}
        inputProps={{
          MenuProps: {
            MenuListProps: {
              sx: {
                backgroundColor: COLORS.DROPDOWN_GREY,
                color: COLORS.WHITE
              }
            }
          }
        }}
      >
        {options.map((option) => (
          <MenuItem key={`${id}${option.toLowerCase()}`} value={option}>
            {option}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default SelectField;
